import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";

import it from 'antd/es/locale/it_IT';

import App from './AppLayout';
import unregister from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

//export const browserHistory = createBrowserHistory({ basename: '' });
//export var reactPlugin = new ReactPlugin();

//const appInsights = new ApplicationInsights({
//    config: {
//        instrumentationKey: process.env.REACT_APP_INSIGHTKEY,
//        disableFetchTracking: false,
//        enableCorsCorrelation: true,
//        enableRequestHeaderTracking: true,
//        enableResponseHeaderTracking: true,
//        extensions: [reactPlugin],
//        extensionConfig: {
//            [reactPlugin.identifier]: { history: browserHistory }
//        }
//    }
//});
//appInsights.loadAppInsights();

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <ConfigProvider locale={it}>
            <App />
        </ConfigProvider>
  </BrowserRouter>,
  rootElement);

//unregister();

navigator.serviceWorker.getRegistrations().then(function (registrations) { for (let registration of registrations) { registration.unregister(); } }); 
